export default __webpack_public_path__ + "static/media/about-us4.0d5cba09.jpeg";